import React from 'react';

import ChartHiddenSeriesOverlay from 'components/charts/chart-hidden-series-overlay';

const DataLabChartHiddenSeriesOverlay: React.FC<React.SVGAttributes<SVGTextElement>> = (props) => {
  return <ChartHiddenSeriesOverlay {...props} message="Every series is hidden." />;
};

export default DataLabChartHiddenSeriesOverlay;
